// extracted by mini-css-extract-plugin
export default {"meetingResultDialog":"client_meetingResultDialog__ZPM5s"};